import React, { useEffect } from 'react';
import { useModal } from '@/core/hooks/useModal';
import { useTranslation } from 'react-i18next';
import ResultHistory from '@/components/features/result/ResultHistory/ResultHistory';
import DottedLink from '@/components/atoms/UI/links/DottedLink';
import { AppDispatch } from '@/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { selectHistory } from '@/store/selectors/resultHistorySelector';
import { selectResultTestId } from '@/store/selectors/resultSelectors';
import { fetchHistoryResultData } from '@/store/reducers/historyResultSlice';

const HistoryModal: React.FC = () => {
	const dispatch: AppDispatch = useDispatch();
	const { show: showHistoryModal, RenderModal: RenderHistoryModal } = useModal();
	const { t } = useTranslation();
	const text_history = t('result.history' as any);

	const { data: historyItems, error, isFetching, isNetworkError } = useSelector(selectHistory);
	const testId = useSelector(selectResultTestId);


	return (
		<>
			<RenderHistoryModal>
				<ResultHistory
					error={error}
					isFetching={isFetching}
					isNetworkError={isNetworkError ?? false}
					onReload={() => dispatch(fetchHistoryResultData(testId))}
				/>
			</RenderHistoryModal>
			<DottedLink onClick={showHistoryModal} white>
				{text_history}
			</DottedLink>
		</>
	);
};

export default HistoryModal;